import React from 'react';
import { Card } from 'components/shadcn/ui/card';
import { Button } from 'components/shadcn/ui/button';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { parseAddressString } from 'components/HGForm/helpers';
import Gravatar from 'react-gravatar';
import { Pencil } from 'lucide-react';

const UserProfile = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const navigate = useNavigate();
    const userAttributes = user?.attributes;
    const fullName = `${userAttributes?.name} ${userAttributes?.family_name}`;

    if (!userAttributes?.email) {
        return null;
    }

    const addressObject = parseAddressString(userAttributes?.address);
    const formatAddress = () => {
        if (!addressObject?.address) return 'N/A';
        if (addressObject.country === 'United States')
            delete addressObject.country;

        const parts = [
            addressObject.address,
            addressObject.city,
            addressObject.stateProvince && addressObject.postalCode
                ? `${addressObject.stateProvince} ${addressObject.postalCode}`
                : addressObject.stateProvince || addressObject.postalCode,
            addressObject.country,
        ].filter(Boolean);

        return parts.join(', ');
    };

    const fields = [
        { label: 'Email', value: userAttributes.email },
        {
            label: 'Phone',
            value: userAttributes.phone_number?.slice(1) || null,
        },
        { label: 'Address', value: formatAddress(), fullWidth: true },
    ];

    return (
        <div className="mx-auto w-full max-w-md">
            <Card className="space-y-5 p-5">
                <div className="flex justify-end">
                    <Button
                        variant="outline"
                        size="icon"
                        onClick={() => navigate('/profile/edit')}
                        aria-label="Edit profile"
                    >
                        <Pencil className="h-4 w-4" />
                    </Button>
                </div>
                <div className="flex flex-col items-center space-y-4">
                    <Gravatar
                        email={userAttributes.email}
                        size={120}
                        rating="pg"
                        default="identicon"
                        className="rounded-full shadow-lg"
                    />
                    <h4 className="text-lg font-semibold">{fullName}</h4>
                </div>
                <div className="space-y-5">
                    {fields.map((field) => (
                        <div
                            key={field.label}
                            className={field.fullWidth ? 'md:col-span-2' : ''}
                        >
                            <div className="space-y-1">
                                <div className="text-sm font-semibold text-gray-700">
                                    {field.label}
                                </div>
                                <div className="text-sm font-light">
                                    {field.value || 'N/A'}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Card>
        </div>
    );
};

export default UserProfile;
